export enum MetalsProductBillOfMaterialsLineItemType {
    Hardware = 'Hardware',
    Product = 'Product',
};